/**
 * 前端共享工具函数 — 消除 5 份 formatCompact + 6 份 escapeHtml + 2 份 humanStatus 副本。
 * 纯函数, 零依赖, 可移植。
 */

/**
 * 将数字格式化为紧凑显示: 1.2M / 3.4K / 123
 * 原先在 5 个文件中各有一份相同实现(aiCreateViewHydrator/articleMetaPainter/
 * navigationController/topicCard/topicDetailHydrator)。
 */
export function formatCompact(n: number): string {
	if (n >= 1_000_000) return `${(n / 1_000_000).toFixed(1).replace(/\.0$/, "")}M`;
	if (n >= 1_000) return `${(n / 1_000).toFixed(1).replace(/\.0$/, "")}K`;
	return String(n);
}

/**
 * HTML 实体转义 — 防 XSS。
 * 对齐 server/services/seo/seoEscape.ts 的转义范围(& < > " ')。
 * 原先在 6 个客户端文件中各有一份实现, 部分缺少单引号转义(安全隐患)。
 */
export function escapeHtml(s: string): string {
	return s
		.replace(/&/g, "&amp;")
		.replace(/</g, "&lt;")
		.replace(/>/g, "&gt;")
		.replace(/"/g, "&quot;")
		.replace(/'/g, "&#39;");
}

/**
 * 社区想法状态 -> 人类可读标签。
 * 原先在 homeRecommendationHydrator/ideaDetailHydrator 各有一份相同实现。
 */
export function humanStatus(s: string): string {
	if (s === "completed" || s === "live") return "Completed";
	if (s === "inprogress" || s === "in_progress" || s === "planned") return "In Progress";
	return "Voting";
}

/**
 * 将 ISO 时间戳格式化为相对时间字符串 ("Just now", "5 min ago", "3 hr ago",
 * "Yesterday" 等)。超过 30 天回退到短日期。
 * Profile 页 History 卡片和 /history 详情页共用此函数。
 */
export function formatRelative(iso: string): string {
	const sqliteUtc = /^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}(?:\.\d+)?$/u.test(iso)
		? `${iso.replace(' ', 'T')}Z`
		: iso;
	const t = new Date(sqliteUtc).getTime();
	if (!Number.isFinite(t)) return "Recently";
	const diff = Date.now() - t;
	const mins = Math.floor(diff / 60000);
	if (mins < 1) return "Just now";
	if (mins < 60) return `${mins} min ago`;
	const hours = Math.floor(mins / 60);
	if (hours < 24) return `${hours} hr ago`;
	const days = Math.floor(hours / 24);
	if (days === 0) return "Today";
	if (days === 1) return "Yesterday";
	if (days < 7) return `${days} days ago`;
	if (days < 30) return `${Math.floor(days / 7)} wk ago`;
	return new Date(sqliteUtc).toLocaleDateString("en-US", { month: "short", day: "numeric" });
}
